import React from 'react';
import * as styles from './author-reviewer.module.scss';

type AuthorSummaryProps = {
  highlights: { value: string }[]
  experience: string
  education: string
  aboutTeethTalk: string
};

const AuthorReviewerSummary = ({
  highlights, experience, education, aboutTeethTalk,
}: AuthorSummaryProps) => (
  <div className={styles.authorSummary}>

    {highlights && highlights.length > 0 && (
      <div>
        <h1 className={styles.summaryTitle}>Highlights</h1>
        <ul>
          {highlights.map((highlight) => (
            <li>
              {highlight.value}
            </li>
          ))}
        </ul>
      </div>
    )}

    <div>
      <h1 className={styles.summaryTitle}>Education</h1>
      <span>
        {education}
      </span>
    </div>

    <div>
      <h1 className={styles.summaryTitle}>Experience</h1>
      <span>{experience}</span>
    </div>

    {aboutTeethTalk && (
      <div>
        <h1 className={styles.summaryTitle}>About Teeth Talk</h1>
        <div dangerouslySetInnerHTML={{ __html: aboutTeethTalk }} />
      </div>
    )}

  </div>
);

export { AuthorReviewerSummary };
